export default __webpack_public_path__ + "static/media/step3_bingo.96600c42.png";